/**
 * See the vite.config.mts for the RegExp alias directing 'react-paginate' to
 * this file.
 *
 * 1. Use a deep import to bypass the alias we are about to create. (If this exact
 *    path throws a "not found" error, look inside node_modules/react-paginate/
 *    to find the exact name of the compiled file, like index.js)
 */
// @ts-expect-error TS7016: Could not find a declaration file for module 'react-paginate/dist/react-paginate.js'. '.../node_modules/react-paginate/dist/react-paginate.js' implicitly has an 'any' type.
import RawPaginate from 'react-paginate/dist/react-paginate.js';

// 2. Safely unwrap the deeply nested default object that is crashing React
const ReactPaginate =
  RawPaginate?.default?.default || RawPaginate?.default || RawPaginate;

// 3. Export it cleanly
export default ReactPaginate;
